import angular from 'angular';
import { ModalFluxoAprovacoesService } from '../modal/fluxoaprovacoes.modal.service';
import { IEquipe, Contas } from '../models/equipe.model';
import { FluxoAprovacoesService } from '../fluxoaprovacoes.service';
import { FluxoAprovacoesConfirmModalService } from '../modal/confirm/fluxoaprovacoesconfirm.modal.service';
import { IProcessoAvaliadorListResponse, IProcessoAvaliadorParametros } from '../models/processo-avaliador.model';
import { ConfigurarLoteModalService } from '../modal/configurarLote/configurarlote.modal.service';

const PROCESSOS_INTERACAO_CODIGOS = [
    'MEURH_SOLICITACOES_ADMISSAO_COMPLETA',
    'MEURH_SOLICITACOES_RESCISAO',
    'MEURH_SOLICITACOES_PROMOCAO',
    'MEURH_MOVIMENTACOES',
] as const;

const PROCESSOS_INTERACAO_TITULOS = [
    'Admissão Completa',
    'Rescisão',
    'Promoção',
    'Movimentações',
] as const;

const PROCESSOS_PARAMETROS_CODIGOS = [
    'MEURH_SOLICITACOES_PROMOCAO',
    'MEURH_SOLICITACOES_FERIAS',
] as const;

export class FluxoAprovacoesIndexController {
    static $inject = ['$scope', 'FluxoAprovacoesService', 'NewToaster', '$rootScope', '$http', 'nsjRouting', '$q',
        '$uibModal', '$state', '$stateParams', 'ModalFluxoAprovacoesService', 'FluxoAprovacoesConfirmModalService', 'ConfigurarLoteModalService'];

    public entity: any = {};
    public activeTab = 1;
    public equipes: IEquipe[] = [];
    public contas: Array<Contas> = [];
    public processosAvaliadores!: IProcessoAvaliadorListResponse[];
    public primeiroAvaliador: any;
    public busy: boolean = false;
    public hasBatchChanges: boolean = false;
    private baselineMap: Map<string, { semavaliador: boolean; gestoravaliador1: boolean; avaliador1: any; avaliador2: any; interacaoAtiva: boolean; interacaoEquipeId: string | null; parametroProgramar: boolean; parametroDias: number | null }> = new Map();
    private baselineProcessoPadrao: { semavaliador: boolean; gestoravaliador1: boolean; avaliador1: any; avaliador2: any; interacaoAtiva: boolean; interacaoEquipeId: string | null; parametroProgramar: boolean; parametroDias: number | null } | null = null;
    private processoPadraoDirty: boolean = false;
    private processoPadrao: IProcessoAvaliadorListResponse | null = null;

    constructor(
        public $scope: any,
        public FluxoAprovacoesService: FluxoAprovacoesService,
        public NewToaster: any,
        public $rootScope: any,
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $q: any,
        public $uibModal: any,
        public $state: any,
        public $stateParams: angular.ui.IStateParamsService,
        public ModalFluxoAprovacoesService: ModalFluxoAprovacoesService,
        public FluxoAprovacoesConfirmModalService: FluxoAprovacoesConfirmModalService,
        public ConfigurarLoteModalService: ConfigurarLoteModalService
    ) {
        this.busy = true;
        if (
            !$rootScope.isAdmin() ||
            ($rootScope.soPossuiPonto())
        ) {
            $state.go('dp', $stateParams);
        }

        this.$scope.$on('equipes_list_finished', (_event: any, data: IEquipe[]) => {
            this.equipes = data;

            this.filtrarEquipes();
            this.initializeInteracoes();
            this.busy = false;
        });

        this.$scope.$on('equipes_submitted', (_event: any, payload: any) => {
            this.NewToaster.pop({
                type: 'success',
                title: 'Equipe salva com sucesso.'
            });

            this.busy = true;
            this.reload();
        });

        this.$scope.$on('equipes_submit_error', (_event: any, payload: any) => {
            // a mensagem ao usuário é exibida pelo modal, que segue aberto
            console.error('Erro ao salvar equipe:', payload.response);
            this.busy = false;
        });
    }

    async $onInit(): Promise<void> {
        this.contas = await this.FluxoAprovacoesService.getContas();

		this.reload();

        this.processosAvaliadores = await this.FluxoAprovacoesService.getProcessosAvaliadores();
        this.processoPadrao = this.FluxoAprovacoesService.getProcessoPadrao();

        this.initializeInteracoes();
        this.setBaseline();
        this.recomputeDirty();
	}

	reload(): void {
		this.FluxoAprovacoesService.reload();
	}

    filtrarEquipes() {
        const contasMap = new Map(this.contas.map(c => [c.email, c.nome]));

        this.equipes = this.equipes.map(equipe => ({
            ...equipe,
            usuarios: Array.isArray(equipe.usuarios)
                ? (equipe.usuarios as any[]).map((u: any) => {
                    const email = typeof u === 'string' ? u : u.email;
                    return {
                        email,
                        nome: contasMap.get(email) || '',
                    } as Contas;
                })
                : equipe.usuarios,
        }));
    }

    openModal(event: any, index: number) {
        let objEquipe: IEquipe | undefined;
        if (event.target.id === 'edit') {
            objEquipe = this.equipes[index];
        }
        this.ModalFluxoAprovacoesService.open(objEquipe);
    }

    openModalAvaliador(event: any, avaliadorDetalhado: any) {
        if (!avaliadorDetalhado) { return; }
        const codigo = avaliadorDetalhado.codigo;
        const titulo = avaliadorDetalhado.titulo;
        const equipe = this.equipes.find(e => (codigo && e.codigo === codigo) || (titulo && e.titulo === titulo));
        if (equipe) {
            this.ModalFluxoAprovacoesService.open(equipe);
        }
    }

    openModalConfirm() {
        const dirty = (this.processosAvaliadores || []).filter((p: any) => p && p._dirty);
        const defaultDirty = this.processoPadraoDirty && !!this.processoPadrao;
        if (!dirty.length && !defaultDirty) {
            return;
        }

        const validationErrors: string[] = [];
        dirty.forEach((p: any) => {
            const erro = this.validarInteracaoObrigatoria(p);
            if (erro) { validationErrors.push(erro); }
            const erroParam = this.validarParametrosObrigatorios(p);
            if (erroParam) { validationErrors.push(erroParam); }
        });

        if (defaultDirty && this.processoPadrao) {
            const erroPadrao = this.validarInteracaoObrigatoria(this.processoPadrao);
            if (erroPadrao) { validationErrors.push(erroPadrao); }
            const erroParamPadrao = this.validarParametrosObrigatorios(this.processoPadrao);
            if (erroParamPadrao) { validationErrors.push(erroParamPadrao); }
        }

        if (validationErrors.length) {
            this.NewToaster.pop({
                type: 'warning',
                title: validationErrors[0],
            });
            return;
        }

        this.busy = true;
        const promises = dirty.map((p: any) => {
            const req: any = {
                processo: p.processo,
                escopoworkflow: p.escopoworkflow,
                semavaliador: !!p.semavaliador,
                gestoravaliador1: !!p.gestoravaliador1,
                avaliador1: p.semavaliador ? null : this.retornaGuidEquipe(p.avaliador1),
                avaliador2: p.semavaliador ? null : this.retornaGuidEquipe(p.avaliador2),
            };

            if (this.processoPossuiInteracao(p)) {
                const interacaoPayload = this.buildInteracaoPayload(p);
                req.interacao = interacaoPayload;
                req.posaprovacao = interacaoPayload.ativa;
                req.equipecliente = interacaoPayload.ativa ? interacaoPayload.equipeId : null;
            }

            if (this.processoPossuiParametros(p)) {
                req.parametros = this.buildParametrosPayload(p);
            }

            const guid = p.processoavaliador;
            if (guid) {
                return this.FluxoAprovacoesService.updateProcessoAvaliador(guid, req);
            }
            return this.FluxoAprovacoesService.createProcessoAvaliador(req);
        });

        if (defaultDirty && this.processoPadrao) {
            const request: any = {
                processo: this.processoPadrao.processo,
                escopoworkflow: this.processoPadrao.escopoworkflow,
                semavaliador: !!this.processoPadrao.semavaliador,
                gestoravaliador1: !!this.processoPadrao.gestoravaliador1,
                avaliador1: this.processoPadrao.semavaliador ? null : this.retornaGuidEquipe(this.processoPadrao.avaliador1),
                avaliador2: this.processoPadrao.semavaliador ? null : this.retornaGuidEquipe(this.processoPadrao.avaliador2),
            };

            if (this.processoPossuiInteracao(this.processoPadrao)) {
                const interacaoPayload = this.buildInteracaoPayload(this.processoPadrao);
                request.interacao = interacaoPayload;
                request.posaprovacao = interacaoPayload.ativa;
                request.equipecliente = interacaoPayload.ativa ? interacaoPayload.equipeId : null;
            }

            if (this.processoPossuiParametros(this.processoPadrao)) {
                request.parametros = this.buildParametrosPayload(this.processoPadrao);
            }

            const guid = this.processoPadrao.processoavaliador;
            promises.push(guid
                ? this.FluxoAprovacoesService.updateProcessoAvaliador(guid, request)
                : this.FluxoAprovacoesService.createProcessoAvaliador(request));
        }

        this.$q.all(promises)
            .then(() => this.FluxoAprovacoesService.getProcessosAvaliadores())
            .then((list: IProcessoAvaliadorListResponse[]) => {
                this.processosAvaliadores = list;
                this.processoPadrao = this.FluxoAprovacoesService.getProcessoPadrao();
                this.initializeInteracoes();
                this.setBaseline();
                this.recomputeDirty();
                this.FluxoAprovacoesConfirmModalService.open();
            })
            .catch((_err: any) => {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao salvar configurações.',
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    onProcessoChange(_index?: number): void { this.hasBatchChanges = true; }

    toggleSemAvaliador(index: number): void {
        const p: any = (this.processosAvaliadores || [])[index];
        if (!p) { return; }
        if (p.semavaliador) {
            p.avaliador1 = null;
            p.avaliador2 = null;
            p.gestoravaliador1 = false;
        }
        this.recomputeDirty();
    }

    onAvaliadorChange(index: number): void {
        const p: any = (this.processosAvaliadores || [])[index];
        if (!p) { return; }
        p.semavaliador = false;
        const a1 = p.avaliador1;
        const isGestor = !!(a1 && (a1.codigo === '__GESTOR__' || a1.titulo === 'Gestor'));
        p.gestoravaliador1 = isGestor;
        this.recomputeDirty();
    }

    shouldRenderInteracao(processo: IProcessoAvaliadorListResponse | null | undefined): boolean {
        return this.processoPossuiInteracao(processo || null);
    }

    onInteracaoToggle(index: number): void {
        const processo = (this.processosAvaliadores || [])[index];
        if (!processo || !this.processoPossuiInteracao(processo)) { return; }

        processo.interacao = processo.interacao || { ativa: false, equipe: null, equipeId: null };
        processo.interacao.ativa = !!processo.interacao.ativa;

        if (!processo.interacao.ativa) {
            processo.interacao.equipe = null;
            processo.interacao.equipeId = null;
            this.ensureInteracaoShape(processo);
            this.recomputeDirty();
            return;
        }

        this.ensureInteracaoShape(processo);

        this.recomputeDirty();
    }

    onInteracaoEquipeChange(index: number): void {
        const processo = (this.processosAvaliadores || [])[index];
        if (!processo || !this.processoPossuiInteracao(processo)) { return; }

        processo.interacao = processo.interacao || { ativa: false, equipe: null, equipeId: null };
        this.ensureInteracaoShape(processo);
        processo.interacao.equipeId = this.retornaGuidEquipe(processo.interacao.equipe) || null;

        this.recomputeDirty();
    }

    shouldRenderParametros(processo: IProcessoAvaliadorListResponse | null | undefined): boolean {
        return this.processoPossuiParametros(processo || null);
    }

    onParametroProgramarToggle(index: number): void {
        const processo = (this.processosAvaliadores || [])[index];
        if (!processo || !this.processoPossuiParametros(processo)) { return; }

        this.ensureParametrosShape(processo);

        const chaveDias = this.getChaveDiasParametro(processo);
        if (processo.parametros!.programar) {
            if (chaveDias) {
                const currentVal = (processo.parametros as any)[chaveDias];
                if (currentVal == null) {
                    (processo.parametros as any)[chaveDias] = this.getDefaultDiasParametro(processo);
                }
            }
        }

        this.recomputeDirty();
    }

    onParametroDiasChange(index: number): void {
        const processo = (this.processosAvaliadores || [])[index];
        if (!processo || !this.processoPossuiParametros(processo)) { return; }

        this.recomputeDirty();
    }

    getChaveDiasParametro(processo: IProcessoAvaliadorListResponse | null | undefined): string {
        if (!processo) { return ''; }
        const codigo = this.normalizarTexto(processo.processo || '');
        if (codigo.includes('PROMOCAO')) { return 'programacao_diasfuturos'; }
        if (codigo.includes('FERIAS')) { return 'programacao_diasantecedencia'; }
        return '';
    }

    getLabelDiasParametro(processo: IProcessoAvaliadorListResponse | null | undefined): string {
        if (!processo) { return ''; }
        const codigo = this.normalizarTexto(processo.processo || '');
        if (codigo.includes('PROMOCAO')) { return 'Dias futuros para envio automático'; }
        if (codigo.includes('FERIAS')) { return 'Dias de antecedência para envio automático'; }
        return '';
    }

    getDescricaoParametro(processo: IProcessoAvaliadorListResponse | null | undefined): string {
        if (!processo) { return ''; }
        const codigo = this.normalizarTexto(processo.processo || '');
        if (codigo.includes('PROMOCAO')) { return 'Será enviada automaticamente para efetivação na data programada da promoção. A quantidade de dias futuros define o limite máximo permitido para essa data.'; }
        if (codigo.includes('FERIAS')) { return 'Será enviada automaticamente para efetivação a solicitação de férias com início em menos de X dias.'; }
        return '';
    }

    getMinDiasParametro(processo: IProcessoAvaliadorListResponse | null | undefined): number {
        if (!processo) { return 0; }
        const codigo = this.normalizarTexto(processo.processo || '');
        if (codigo.includes('FERIAS')) { return 35; }
        return 0;
    }

    getMaxDiasParametro(processo: IProcessoAvaliadorListResponse | null | undefined): number {
        if (!processo) { return 120; }
        const codigo = this.normalizarTexto(processo.processo || '');
        if (codigo.includes('FERIAS')) { return 60; }
        return 120;
    }

    getDefaultDiasParametro(processo: IProcessoAvaliadorListResponse | null | undefined): number {
        if (!processo) { return 1; }
        const codigo = this.normalizarTexto(processo.processo || '');
        if (codigo.includes('FERIAS')) { return 35; }
        return 1;
    }

    configurarLote() {
        this.processoPadrao = this.processoPadrao || this.FluxoAprovacoesService.getProcessoPadrao();
        if (!this.processoPadrao) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível carregar a configuração padrão para edição.',
            });
            return;
        }

        const modal = this.ConfigurarLoteModalService.open(this.processoPadrao);
        modal.result.then((payload: any) => {
            if (!payload) { return; }
            this.atualizarProcessoPadrao(payload);
        });
    }

    private retornaGuidEquipe(val: any): any {
        if (!val) { return null; }

        if (typeof val === 'string') { return val; }
        if (Object.prototype.hasOwnProperty.call(val, 'equipe')) { return val.equipe; }
        if (Object.prototype.hasOwnProperty.call(val, 'avaliador')) { return val.avaliador; }
        if (Object.prototype.hasOwnProperty.call(val, 'avaliador1')) { return val.avaliador1; }
        if (Object.prototype.hasOwnProperty.call(val, 'avaliador2')) { return val.avaliador2; }
        return null;
    }

    private initializeInteracoes(): void {
        (this.processosAvaliadores || []).forEach((processo) => {
            this.ensureInteracaoShape(processo);
            this.ensureParametrosShape(processo);
        });
        if (this.processoPadrao) {
            this.ensureInteracaoShape(this.processoPadrao);
            this.ensureParametrosShape(this.processoPadrao);
        }
    }

    private ensureInteracaoShape(processo: IProcessoAvaliadorListResponse | null | undefined): void {
        if (!processo) { return; }

        if (!this.processoPossuiInteracao(processo)) {
            processo.interacao = { ativa: false, equipe: null, equipeId: null };
            return;
        }

        const interacao = processo.interacao || { ativa: false, equipe: null, equipeId: null };
        interacao.ativa = !!interacao.ativa;

        if (!interacao.ativa) {
            interacao.equipe = null;
            interacao.equipeId = null;
            processo.interacao = interacao;
            return;
        }

        interacao.equipeId = interacao.equipeId || this.retornaGuidEquipe(interacao.equipe) || null;
        if (!interacao.equipe && interacao.equipeId) {
            interacao.equipe = this.findEquipePorId(interacao.equipeId) || interacao.equipe;
        }
        processo.interacao = interacao;
    }

    private findEquipePorId(id: string | null): IEquipe | null {
        if (!id) {
            return null;
        }

        const fromService = (this.FluxoAprovacoesService.entities || []).find((item: IEquipe) => item && item.equipe === id);
        if (fromService) {
            return fromService;
        }

        return (this.equipes || []).find((item) => item && item.equipe === id) || null;
    }

    private validarInteracaoObrigatoria(processo: any): string | null {
        if (!processo || !this.processoPossuiInteracao(processo)) {
            return null;
        }

        this.ensureInteracaoShape(processo);

        const interacao = processo.interacao || { ativa: false, equipe: null, equipeId: null };

        if (!interacao.ativa) {
            return null;
        }

        const equipeId = interacao.equipeId || this.retornaGuidEquipe(interacao.equipe);
        if (equipeId) {
            return null;
        }

        const titulo = processo.titulo || processo.processo || 'este processo';
        return `Selecione a equipe de interação para ${titulo}.`;
    }

    private buildInteracaoPayload(processo: any): { ativa: boolean; equipeId: string | null } {
        if (!this.processoPossuiInteracao(processo)) {
            return { ativa: false, equipeId: null };
        }

        processo.interacao = processo.interacao || { ativa: false, equipe: null, equipeId: null };
        this.ensureInteracaoShape(processo);

        if (!processo.interacao.ativa) {
            return { ativa: false, equipeId: null };
        }

        const equipeId = processo.interacao.equipeId || this.retornaGuidEquipe(processo.interacao.equipe) || null;
        processo.interacao.equipeId = equipeId;

        return {
            ativa: true,
            equipeId,
        };
    }

    private buildParametrosPayload(processo: any): IProcessoAvaliadorParametros {
        if (!this.processoPossuiParametros(processo)) {
            return { programar: false };
        }

        this.ensureParametrosShape(processo);
        const params = processo.parametros as IProcessoAvaliadorParametros;
        const chaveDias = this.getChaveDiasParametro(processo);

        const result: IProcessoAvaliadorParametros = {
            programar: !!params.programar
        };

        if (chaveDias) {
            const currentVal = (params as any)[chaveDias];
            (result as any)[chaveDias] = currentVal != null ? currentVal : this.getDefaultDiasParametro(processo);
        }

        return result;
    }

    private validarParametrosObrigatorios(processo: any): string | null {
        if (!processo || !this.processoPossuiParametros(processo)) { return null; }

        this.ensureParametrosShape(processo);
        const params = processo.parametros as IProcessoAvaliadorParametros;

        if (!params.programar) { return null; }

        if (this.isProcessoPromocao(processo)) {
            this.ensureInteracaoShape(processo);
            const interacao = processo.interacao || { ativa: false, equipe: null, equipeId: null };
            if (!interacao.ativa) {
                const titulo = processo.titulo || processo.processo || 'este processo';
                return `Ative a equipe de interação para ${titulo}.`;
            }
            const equipeId = interacao.equipeId || this.retornaGuidEquipe(interacao.equipe);
            if (!equipeId) {
                const titulo = processo.titulo || processo.processo || 'este processo';
                return `Selecione a equipe de interação para ${titulo}.`;
            }
        }

        const chaveDias = this.getChaveDiasParametro(processo);
        if (!chaveDias) { return null; }

        const dias = (params as any)[chaveDias];
        if (dias == null) {
            const titulo = processo.titulo || processo.processo || 'este processo';
            return `Informe a quantidade de dias para ${titulo}.`;
        }

        const min = this.getMinDiasParametro(processo);
        if (dias < min) {
            const titulo = processo.titulo || processo.processo || 'este processo';
            return `A quantidade mínima de dias para ${titulo} é ${min}.`;
        }

        const max = this.getMaxDiasParametro(processo);
        if (dias > max) {
            const titulo = processo.titulo || processo.processo || 'este processo';
            return `A quantidade máxima de dias para ${titulo} é ${max}.`;
        }

        return null;
    }

    private isProcessoPromocao(processo: IProcessoAvaliadorListResponse | null | undefined): boolean {
        if (!processo) { return false; }
        const codigoNormalizado = this.normalizarTexto(processo.processo || '');
        if (codigoNormalizado.includes('PROMOCAO')) {
            return true;
        }
        const tituloNormalizado = this.normalizarTexto(processo.titulo || '');
        return tituloNormalizado.includes('PROMOCAO');
    }

    private ensureParametrosShape(processo: IProcessoAvaliadorListResponse | null | undefined): void {
        if (!processo) { return; }
        if (!this.processoPossuiParametros(processo)) { return; }

        if (!processo.parametros || typeof processo.parametros !== 'object') {
            processo.parametros = { programar: false };
        }
    }

    private processoPossuiParametros(processo: IProcessoAvaliadorListResponse | null): boolean {
        if (!processo) { return false; }
        const codigoNormalizado = this.normalizarTexto(processo.processo || '');

        return PROCESSOS_PARAMETROS_CODIGOS.some((c) => codigoNormalizado.includes(this.normalizarTexto(c)));
    }

    private processoPossuiInteracao(processo: IProcessoAvaliadorListResponse | null): boolean {
        if (!processo) { return false; }

        const codigoNormalizado = this.normalizarTexto(processo.processo || '');
        const titulosNormalizados = PROCESSOS_INTERACAO_TITULOS.map((t) => this.normalizarTexto(t));
        const codigosNormalizados = PROCESSOS_INTERACAO_CODIGOS.map((c) => this.normalizarTexto(c));

        if (codigoNormalizado && codigosNormalizados.some((target) => target && codigoNormalizado.includes(target))) {
            return true;
        }

        if (codigoNormalizado.includes('ADMISSAO') && codigoNormalizado.includes('COMPLETA')) {
            return true;
        }

        if (codigoNormalizado.includes('RESCISAO')) {
            return true;
        }

        const tituloNormalizado = this.normalizarTexto(processo.titulo || '');
        if (!tituloNormalizado) {
            return false;
        }

        if (titulosNormalizados.includes(tituloNormalizado)) {
            return true;
        }

        if (tituloNormalizado.includes('ADMISSAO') && tituloNormalizado.includes('COMPLETA')) {
            return true;
        }

        if (tituloNormalizado.includes('RESCISAO')) {
            return true;
        }

        return false;
    }

    private normalizarTexto(valor: string | null | undefined): string {
        if (!valor) {
            return '';
        }

        const upper = valor.toUpperCase();
        if (typeof upper.normalize === 'function') {
            return upper.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
        return upper;
    }

    private keyForProcesso(p: any): string {
        return p.processoavaliador || p.processo;
    }

    private snapshotOf(p: any) {
        const semAvaliador = !!(p && p.semavaliador);
        const interacao = p && p.interacao ? p.interacao : { ativa: false, equipe: null, equipeId: null };
        const interacaoAtiva = !!interacao.ativa;
        const interacaoEquipeId = interacaoAtiva ? (interacao.equipeId || this.retornaGuidEquipe(interacao.equipe)) : null;

        const params = p && p.parametros ? p.parametros : { programar: false };
        const parametroProgramar = !!params.programar;
        const parametroDias = parametroProgramar
            ? (params.programacao_diasfuturos || params.programacao_diasantecedencia || null)
            : null;

        return {
            semavaliador: semAvaliador,
            gestoravaliador1: !!(p && p.gestoravaliador1),
            avaliador1: semAvaliador ? null : this.retornaGuidEquipe(p ? p.avaliador1 : null),
            avaliador2: semAvaliador ? null : this.retornaGuidEquipe(p ? p.avaliador2 : null),
            interacaoAtiva,
            interacaoEquipeId,
            parametroProgramar,
            parametroDias,
        };
    }

    private setBaseline(): void {
        this.baselineMap.clear();
        (this.processosAvaliadores || []).forEach((p: any) => {
            if (!p) { return; }
            this.ensureInteracaoShape(p);
            this.baselineMap.set(this.keyForProcesso(p), this.snapshotOf(p));
        });
        if (this.processoPadrao) {
            this.ensureInteracaoShape(this.processoPadrao);
        }
        this.baselineProcessoPadrao = this.processoPadrao ? this.snapshotOf(this.processoPadrao) : null;
        this.processoPadraoDirty = false;
    }

    private recomputeDirty(): void {
        const processos = this.processosAvaliadores || [];
        let anyDirty = false;
        processos.forEach((processoavaliador: any) => {
            if (!processoavaliador) { return; }
            this.ensureInteracaoShape(processoavaliador);
            const key = this.keyForProcesso(processoavaliador);
            const baseline = this.baselineMap.get(key);
            const current = this.snapshotOf(processoavaliador);
            const isDirty = !baseline
                || baseline.semavaliador !== current.semavaliador
                || baseline.gestoravaliador1 !== current.gestoravaliador1
                || baseline.avaliador1 !== current.avaliador1
                || baseline.avaliador2 !== current.avaliador2
                || baseline.interacaoAtiva !== current.interacaoAtiva
                || baseline.interacaoEquipeId !== current.interacaoEquipeId
                || baseline.parametroProgramar !== current.parametroProgramar
                || baseline.parametroDias !== current.parametroDias;
            processoavaliador._dirty = !!isDirty;
            anyDirty = anyDirty || processoavaliador._dirty;
        });
        const defaultDirty = this.isProcessoPadraoDirty();
        this.processoPadraoDirty = defaultDirty;
        this.hasBatchChanges = anyDirty || defaultDirty;
    }

    private atualizarProcessoPadrao(payload: { semAvaliadores: boolean; avaliador1: any; avaliador2: any }): void {
        if (!this.processoPadrao) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Configuração padrão não encontrada.',
            });
            return;
        }

        const semAvaliadores = !!payload.semAvaliadores;
        const gestorSelecionado = !semAvaliadores && this.isGestor(payload.avaliador1);

        this.processoPadrao.semavaliador = semAvaliadores;
        this.processoPadrao.gestoravaliador1 = gestorSelecionado;
        this.processoPadrao.avaliador1 = semAvaliadores ? null : (payload.avaliador1 ? angular.copy(payload.avaliador1) : null);
        this.processoPadrao.avaliador2 = semAvaliadores ? null : (payload.avaliador2 ? angular.copy(payload.avaliador2) : null);

        this.FluxoAprovacoesService.setProcessoPadrao(this.processoPadrao);
        this.aplicarConfiguracaoLoteNaLista(payload);
        this.recomputeDirty();
    }

    private isGestor(avaliador: any): boolean {
        return !!(avaliador && (avaliador.codigo === '__GESTOR__' || avaliador.titulo === 'Gestor'));
    }

    private isProcessoPadraoDirty(): boolean {
        if (!this.processoPadrao) {
            return false;
        }

        this.ensureInteracaoShape(this.processoPadrao);
        const current = this.snapshotOf(this.processoPadrao);
        if (!this.baselineProcessoPadrao) {
            return true;
        }

        return this.baselineProcessoPadrao.semavaliador !== current.semavaliador
            || this.baselineProcessoPadrao.gestoravaliador1 !== current.gestoravaliador1
            || this.baselineProcessoPadrao.avaliador1 !== current.avaliador1
            || this.baselineProcessoPadrao.avaliador2 !== current.avaliador2
            || this.baselineProcessoPadrao.interacaoAtiva !== current.interacaoAtiva
            || this.baselineProcessoPadrao.interacaoEquipeId !== current.interacaoEquipeId
            || this.baselineProcessoPadrao.parametroProgramar !== current.parametroProgramar
            || this.baselineProcessoPadrao.parametroDias !== current.parametroDias;
    }

    private aplicarConfiguracaoLoteNaLista(payload: { semAvaliadores: boolean; avaliador1: any; avaliador2: any }): void {
        const processos = this.processosAvaliadores || [];
        const semAvaliadores = !!payload.semAvaliadores;
        const selectedIsGestor = !semAvaliadores && this.isGestor(payload.avaliador1);

        processos.forEach((processo: any) => {
            if (!processo) { return; }

            if (semAvaliadores) {
                processo.semavaliador = true;
                processo.gestoravaliador1 = false;
                if ('avaliador1' in processo) { processo.avaliador1 = null; }
                if ('avaliador2' in processo) { processo.avaliador2 = null; }
            } else {
                processo.semavaliador = false;

                if (payload.avaliador1 !== undefined) {
                    if (selectedIsGestor) {
                        if (processo.processo !== 'MEURH_SOLICITACOES_ADMISSAO_COMPLETA') {
                            processo.gestoravaliador1 = true;
                            processo.avaliador1 = { equipe: null, codigo: '__GESTOR__', titulo: 'Gestor' };
                        } else {
                            processo.gestoravaliador1 = false;
                            if (processo.avaliador1 && this.isGestor(processo.avaliador1)) {
                                processo.avaliador1 = null;
                            }
                        }
                    } else {
                        processo.gestoravaliador1 = false;
                        processo.avaliador1 = payload.avaliador1 ? angular.copy(payload.avaliador1) : null;
                    }
                }

                if (payload.avaliador2 !== undefined) {
                    processo.avaliador2 = payload.avaliador2 ? angular.copy(payload.avaliador2) : null;
                }
            }

            this.baselineMap.set(this.keyForProcesso(processo), this.snapshotOf(processo));
            processo._dirty = false;
        });
    }
}
